module.exports = __webpack_public_path__ + "files/a766c34d7bdd74fd2ae627746b555869.png";